import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-application-description',
  templateUrl: './application-description.component.html',
  styleUrls: ['./application-description.component.scss']
})
export class ApplicationDescriptionComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
  ) {}
}
